import { MONTH_NAMES, yearOptions } from "@/lib/resumeEditor/date";
import type { DateValue } from "@/lib/resumeEditor/types";

const YEARS = yearOptions();
const selectClass =
  "rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-sm text-slate-700 focus:border-violet-400 focus:outline-none dark:border-slate-700 dark:bg-[#0f172a] dark:text-slate-200";

export default function DateValueInput({
  value,
  onChange,
  current,
  onCurrentChange,
  currentLabel = "Present",
}: {
  value: DateValue | undefined;
  onChange: (value: DateValue) => void;
  current?: boolean;
  onCurrentChange?: (current: boolean) => void;
  currentLabel?: string;
}) {
  const month = value?.month ?? "";
  const year = value?.year ?? "";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <select
        className={selectClass}
        value={month}
        disabled={current}
        onChange={(e) => onChange({ month: e.target.value, year })}
      >
        <option value="">Month</option>
        {MONTH_NAMES.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
      <select
        className={selectClass}
        value={year}
        disabled={current}
        onChange={(e) => onChange({ month, year: e.target.value })}
      >
        <option value="">Year</option>
        {YEARS.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
      {onCurrentChange ? (
        <label className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400">
          <input type="checkbox" checked={!!current} onChange={(e) => onCurrentChange(e.target.checked)} />
          {currentLabel}
        </label>
      ) : null}
    </div>
  );
}
